// extracted by mini-css-extract-plugin
module.exports = {"btnsAlign":"ServiceUsers_btnsAlign__TjQwX"};